import * as React from "react";
import PropTypes from "prop-types";
import Spinner from "react-spinkit";

export default class EditableCellComponent extends React.Component {
  inputRef = "ref";

  componentDidUpdate(prevProps, prevState) {
    if (this.props.focused && this.props.checked)
      this.refs[this.inputRef].focus();
  }

  render() {
    const loading = this.props.loading;
    let className = "editable-cell";

    if (loading) {
      className += " loading";
    } else if (this.props.focused && this.props.checked) {
      className += " focused";
    }
    return (
      <div className={className} onClick={this.props.onClick}>
        {loading && <Spinner fadeIn="none" name="wave" />}
        <span>{this.props.displayedValue || this.props.value}</span>
        {this.props.checked && (
          <input
            ref={this.inputRef}
            id={this.props.id}
            name={this.props.name}
            type={this.props.inputType}
            value={this.props.value}
            onChange={this.props.onChange}
            // onFocus={this.props.onFocus}
            autoFocus={this.props.focused}
            onKeyDown={this.props.onKeyDown}
            min={this.props.min}
          />
        )}
      </div>
    );
  }
}

const inputTypes = [
  "color",
  "date",
  "datetime-local",
  "email",
  "month",
  "number",
  "password",
  "range",
  "tel",
  "text",
  "time",
  "url",
  "week",
];

EditableCellComponent.propTypes = {
  displayedValue: PropTypes.any,
  id: PropTypes.string.isRequired,
  focused: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  inputType: PropTypes.oneOf(inputTypes).isRequired,
  loading: PropTypes.bool,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};



// WEBPACK FOOTER //
// ./src/component/react-table/editable-cell/editable-cell-component.js